module.exports = __webpack_public_path__ + "img/Icon feather-instagram.73e8ba61.svg";